import React, {Component} from 'react';
import { Nav, TabPane, NavItem, Row, NavLink, TabContent, Col, Card, CardHeader, FormText, CardBody, Button, CardFooter, Modal, ModalHeader, ModalFooter, ModalBody, Input, FormGroup, Label , Badge } from 'reactstrap';
import classnames from 'classnames';
import Widget04 from '../../Widgets/Widget04';
import { Redirect } from 'react-router-dom';
import './upload.css';
import $ from 'jquery';
import { connect } from 'react-redux';
import ReactHLS from 'react-hls';

class StoreStoryboardDetailsPage extends Component {


  constructor(props) {
    super(props);
    this.state = {
      navigate: false,
      path:"",
      uploadModalOpen:false,
      editShotModalOpen:false,
      detailsShotModalOpen:false,
      activeShotTab:'1',
      activeTab:'1',
      contentStatus:false
    }
    this.uploadModalOpen = this.uploadModalOpen.bind(this);
    this.uploadModalClose = this.uploadModalClose.bind(this);
    this.toggle = this.toggle.bind(this);
    this.detailsShotOpen = this.detailsShotOpen.bind(this);
    this.detailsShotClose = this.detailsShotClose.bind(this);
    this.shotToggle = this.shotToggle.bind(this);
    this.renderDetailsBody = this.renderDetailsBody.bind(this);
    this.ReleaseToLive = this.ReleaseToLive.bind(this);
    this.suspend = this.suspend.bind(this);
    this.release = this.release.bind(this);
  }

  componentWillMount() {
      let cId = this.props.user.customerId;
      let authToken = this.props.user.authToken;
      let id = parseInt(this.props.match.params.Id);
      $.ajax({
          url: `https://screen.mobflic.com/v1/customers/${cId}/storyboards/${id}`,
          type: 'GET',
          beforeSend: function (xhr) {
                  xhr.setRequestHeader ("X-Auth-Token",authToken);
          },
          success: (res,a,b) => {
            console.log(res);
            this.setState({ scriptDetail :res.result, contentStatus:true})


          },

          error: (res,a,b) => {
              console.log(res);
          }


      });

    }

  suspend() {
      let cId = this.props.user.customerId;
      let authToken = this.props.user.authToken;
      let id = parseInt(this.props.match.params.Id);
      $.ajax({
          url: `https://screen.mobflic.com/v1/customers/${cId}/storyboards/${id}/suspend`,
          type: 'POST',
          beforeSend: function (xhr) {
                  xhr.setRequestHeader ("X-Auth-Token",authToken);
          },
          success: (res,a,b) => {
            console.log(res);
            this.setState({navigate:true, path:"YourStoryboards"});
          },

          error: (res,a,b) => {
              console.log(res);
          }
      });
  }

  release() {
    let sId = this.state.scriptDetail.id;
    let cId = this.props.user.customerId;
    let authToken = this.props.user.authToken;

    let data = {
      hires:true
     };
     let jsonData = JSON.stringify(data);

     $.ajax({
          url: `https://screen.mobflic.com/v1/customers/${cId}/storyboards/${sId}/release`,
          type: 'POST',
          data: jsonData,
          beforeSend: function (xhr) {
                  xhr.setRequestHeader ("X-Auth-Token",authToken);
          },
          success: (res,a,b) => {
            this.setState({
              path:"YourStoryboards",
              navigate:true
            })
         },
        error: (res,a,b) => {
            console.log(res);
            this.setState({releaseFailureOpen:true})
            this.setState({msg: res.messages})
        }
      });
  }

  shotToggle(tab) {
    if (this.state.activeShotTab !== tab) {
      this.setState({
        activeShotTab: tab
      });
    }

  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  redirectModifyPage() {
    this.setState({
      navigate:true,
      path:"YourStoryboards/Edit/1"
    })
  }

  detailsShotOpen() {
    this.setState({
      detailsShotModalOpen:true
    })
  }


  detailsShotClose() {
    this.setState({
      detailsShotModalOpen:false
    })
  }

  uploadModalOpen() {
    this.setState({
      uploadModalOpen: true
    });
  }

  uploadModalClose() {
    this.setState({
      uploadModalOpen: false
    });
  }

    ReleaseToLive() {

        let cId = this.props.user.customerId;
        let sId = parseInt(this.props.match.params.Id);
        let authToken = this.props.user.authToken;

       $.ajax({
          url: `https://screen.mobflic.com/v1/current-user/projects`,
          type: 'GET',
          beforeSend: function (xhr) {
                  xhr.setRequestHeader ("X-Auth-Token",authToken);
          },
          success: (res,a,b) => {

            for (var i=0;i<res.result.projects.length;i++)
            {
                if (res.result.projects[i].projectType == "Live") {

                  let data = {projectId:res.result.projects[i].id}
                  let jsonData = JSON.stringify(data);
                  $.ajax({
                      url: `https://screen.mobflic.com/v1/customers/${cId}/storyboards/${sId}/project`,
                      type: 'POST',
                      contentType:"application/json",
                      data:jsonData,
                      beforeSend: function (xhr) {
                              xhr.setRequestHeader ("X-Auth-Token",authToken);
                      },
                      success: (res) => {
                       this.setState({
                        navigate:true,
                        path:"YourStoryboards"
                       })
                      },
                      error: (res,a,b) => {
                          console.log(res);
                      }


                  });
                };
            }
           console.log(res);
         },
        error: (res,a,b) => {
            console.log(res);
        }

      });


    }

  renderDetailsBody() {

    if(this.state.contentStatus) {

      const showSuspendButton = this.state.scriptDetail.status === "Published";
      const showReleaseButton = this.state.scriptDetail.status === "Draft";

      return (
        <div>


      <Row style={{marginTop:"20px",marginBottom:"10px"}}>
        <Col xs="3">
          <Button style={{"borderRadius":"5px"}} color="success" onClick={() => this.ReleaseToLive()}>Move back to Live</Button>
        </Col>
        <Col xs="6">
        </Col>
         <Col xs="3">
          {
            showSuspendButton ? <Button style={{"borderRadius":"5px"}} color="success" onClick={() => this.suspend()} >Suspend</Button> : null
          }
          {
            showReleaseButton ? <Button style={{"borderRadius":"5px"}} color="success" onClick={() => this.release()} >Release</Button> : null
          }
        </Col>
      </Row>

             <Row style={{marginTop:"20px"}}>
          <Col xs="6" >
            <Card>
              <CardHeader>
               <strong> Storyboards Details </strong>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col>
                    <FormGroup row>
                      <Col xs="12" >
                        <h2 >  <Label>Title</Label> </h2>
                      </Col>
                      <Col xs="12" >
                       <p> { this.state.scriptDetail.title } </p>
                      </Col>
                    </FormGroup>
                  </Col>
                </Row>

                 <Row>
                  <Col>
                    <FormGroup row>
                      <Col xs="12" >
                        <h2 > <Label>Description</Label> </h2>
                      </Col>
                      <Col xs="12">
                        <p>
                         { this.state.scriptDetail.description }
                        </p>
                      </Col>
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <FormGroup row>
                      <Col xs="12" >
                        <h2 > <Label>Status</Label> </h2>
                      </Col>
                      <Col xs="12">
                        <p>
                         { this.state.scriptDetail.status }
                        </p>
                      </Col>
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>

           <Col xs="6" >
            <Card>
              <CardHeader>
               <strong> Storyboards Assets </strong>
              </CardHeader>
              <CardBody>
            <Col xs="12" className="mb-4">
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeAssetTab === '11' })}
                  onClick={() => { this.assetToggle('11'); }}
                >
                 Video
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeAssetTab === '22' })}
                  onClick={() => { this.assetToggle('22'); }}
                >
                  Cover Image
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={this.state.activeAssetTab}>
              <TabPane style={{ verticalAlign:"center", textAlign:"center", height:"222px",width:"100%"}} tabId="11">
              {
                (typeof this.state.scriptDetail.explanationAssetId !== 'undefined') &&  this.state.scriptDetail.explanationAssetId && this.state.scriptDetail.explanationAssetId.length > 0?
                   (this.state.scriptDetail.explanationAssetId.substr(this.state.scriptDetail.explanationAssetId.length-1,1)=="8"?
                     <ReactHLS style={{"marginLeft":"2%", "height":"222px", "width":"auto"}} videoProps={{"height":"222","width":"auto"}} url={"https://screen.mobflic.com/v1/customers/"+  this.props.user.customerId+ "/assets/" + encodeURIComponent(this.state.scriptDetail.explanationAssetId) + "?storyboardId=" + this.state.scriptDetail.id + "&authToken=" + this.props.user.authToken}/>:
                     <video style={{"marginLeft":"2%", "height":"222px", "width":"auto"}} width="auto" height="222" controls src={"https://screen.mobflic.com/v1/customers/"+  this.props.user.customerId+ "/assets/" + encodeURIComponent(this.state.scriptDetail.explanationAssetId) + "?storyboardId=" + this.state.scriptDetail.id + "&authToken=" + this.props.user.authToken}></video>
                   ): null
              }
              </TabPane>
              <TabPane style={{verticalAlign:"center", textAlign:"center", height:"222px",width:"100%"}}  tabId="22">
              {
                this.state.scriptDetail.landScapeImageAssetId?
                <img style={{"height":"100%"}} src={"https://screen.mobflic.com/v1/customers/"+  this.props.user.customerId+ "/assets/" + encodeURIComponent(this.state.scriptDetail.landScapeImageAssetId) + "?storyboardId=" + this.state.scriptDetail.id + "&authToken=" + this.props.user.authToken} />
                :null
              }
              </TabPane>
            </TabContent>
            </Col>
              </CardBody>

            <CardFooter  > </CardFooter>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xs="6">
            <Widget04 icon="icon-frame" style={{backgroundColor:"#63C2E4", color:"#ffffff"}} header={this.state.scriptDetail.assets.length}>SHOTS</Widget04>
          </Col>
          <Col xs="6">
            <Widget04 icon="icon-camrecorder" style={{backgroundColor:"#82D19D", color:"#ffffff"}} header={this.state.scriptDetail.shots.length}>USER GENERATED SHOTS</Widget04>
          </Col>
        </Row>


        <Row>



          {

                  this.state.scriptDetail.shots.map((item) => {
                    return (

                            <Col xs="4">
                              <Card>
                                      <CardHeader>
                                         Shot #{item.shotNumber}. { item.originalFileName }

                                          <Badge style={{float:"right"}} color="success">UGV</Badge>

                                        </CardHeader>
                                        <CardBody >
                                          <p> { item.title } </p>
                                          <p> { item.description } </p>
                                          <p> { item.durationMillis} ms</p>
                                          <p> <i className="fa fa-edit fa-lg mt-4"></i> <a style = {{color:"#00a0e9", cursor:"pointer"}} onClick = {() => {this.detailsShotOpen(item)}}> More Details</a></p>

                                          <div style={{height:"166px"}}>
                                          {
                                            item.imageAssetId?
                                            <img style={{"height":"100%","width":"100%"}} src={"https://screen.mobflic.com/v1/customers/"+  this.props.user.customerId+ "/assets/" + encodeURIComponent(item.imageAssetId) + "?storyboardId=" + this.state.scriptDetail.id + "&authToken=" + this.props.user.authToken} />
                                            :null
                                          }
                                          </div>


                                        </CardBody>
                                  </Card>
                            </Col>


                    );
                  })

              }


         </Row>
        </div>



       )

    } else {
      return;
    }

  }


  render() {

    const { navigate, path } = this.state

    // here is the important part
    if (navigate) {
      console.log(path);
      return <Redirect to={ "/" + path } push={true} />
    }
    return (
      <div className="animated fadeIn">
        {this.renderDetailsBody()}


      </div>
    )
  }
}

function mapStateToProps(state) {
    return {
        user: state.activeUser,
    };
}


export default connect(mapStateToProps)(StoreStoryboardDetailsPage);



// WEBPACK FOOTER //
// ./src/views/Components/StoreStoryboardDetails/storeStoryboardDetails.js